import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Collapsible from './Collapsible';
import CollapsibleHeader from './Header';
/**
 * @extends {React.Component<import('./types').CollapsibleGroupHeaderProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var CollapsibleGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapsibleGroup, _React$Component);

  function CollapsibleGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollapsibleGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollapsibleGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderGroupHeader = function (caption, isOpen) {
      return React.createElement(CollapsibleHeader, {
        caption: caption,
        open: isOpen,
        elevation: _this.props.elevation,
        classParentString: _this.props.classes.collapsible
      });
    };

    return _this;
  }

  _createClass(CollapsibleGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          renderChildren = _this$props.renderChildren,
          children = _this$props.children,
          caption = _this$props.caption,
          onOpening = _this$props.onOpening,
          onClosing = _this$props.onClosing,
          closed = _this$props.closed,
          rest = _objectWithoutProperties(_this$props, ["classes", "renderChildren", "children", "caption", "onOpening", "onClosing", "closed"]);

      return React.createElement(Collapsible, Object.assign({
        classParentString: classes.collapsible,
        trigger: this.renderGroupHeader(caption, false),
        open: !closed,
        onOpening: onOpening,
        onClosing: onClosing,
        contentInnerClassName: classes.innerContent,
        triggerWhenOpen: this.renderGroupHeader(caption, true)
      }, rest), children || renderChildren);
    }
  }]);

  return CollapsibleGroup;
}(React.Component);

var styles = function styles(theme) {
  return {
    collapsible: {},
    innerContent: {
      paddingBottom: theme.spacing(1)
    }
  };
};

CollapsibleGroup.defaultProps = {
  caption: 'Group',
  lazyRender: true,
  'data-testid': 'collapse-group'
};
export default withStyles(styles, {
  name: 'ECCollapsibleGroup'
})(CollapsibleGroup);